import { makeStyles } from '@mui/styles';
/* istanbul ignore next */
const useStyles = makeStyles(({ palette }) => ({
  '@global': {
    '*': {
      outlineColor: palette.brand.main,
    },
    body: {
      color: palette.text.onMain,
    },
  },
}));

/* istanbul ignore next */
const GlobalCss = ({ children }) => {
  useStyles();
  return <>{children}</>;
};

export default GlobalCss;
